import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vue2TouchEvents from 'vue2-touch-events'
Vue.config.productionTip = false
Vue.use(Vue2TouchEvents)

import {scrollHandler} from './mixin.js'

// Vue.mixin(scrollHandler)
import VueSanitize from "vue-sanitize";
Vue.use(VueSanitize);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
